<wvr-tab-component [tabText]="tabText">
  <ng-content></ng-content>
</wvr-tab-component>
